<template>
  <StyledModal :visible="visible" :title="`${isAdd ? '新建' : '编辑'}活动`" @close="close" @submit="submit" :submitLoading="submitLoading" width="700px">
    <el-form class="form_box" ref="formRef" :model="formModel.form" label-width="120px">
      <el-form-item label="活动名称" prop="activeName" :rules="[{ required: true, message: '请输入活动名称' }]">
        <el-input v-model="formModel.form.activeName" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="封面" prop="activeImg" :rules="[{ required: true, message: '请添加封面' }]">
        <div>
          <div><ImgUpload v-model="formModel.form.activeImg" :limit="1" /></div>
          <div>建议尺寸 340*240</div>
        </div>
      </el-form-item>
      <el-form-item
        label="排序"
        prop="activeSeq"
        :rules="[
          { required: true, message: '请输入排序' },
          { type: 'number', min: 0, max: 99999, message: '请输入0-99999之间的数字' },
        ]"
      >
        <el-input v-model.number="formModel.form.activeSeq" placeholder="0-99999之间"></el-input>
      </el-form-item>
    </el-form>
  </StyledModal>
</template>

<script>
import { reactive, ref, computed } from 'vue'
import { cloneDeep } from 'lodash'
import StyledModal from '@/components/modal/StyledModal/index.vue'
import ImgUpload from '@/components/ImgUpload'
import FetchSelect from '@/components/FetchSelect'
import DetailEditor from '@/components/DetailEditor'
import { validateFormRef } from '@/common/utils_element'
import request from '@/utils/request'
import { trimAll } from '@/utils/utils'

const defaultForm = {
  activeName: '',
  activeImg: '',
  activeSeq: '',
}

export default {
  emits: ['successAdd', 'successEdit'],
  setup(_, ctx) {
    const visible = ref(false)
    const submitLoading = ref(false)

    const formRef = ref(null)
    const formModel = reactive({
      form: cloneDeep(defaultForm),
    })

    const record = reactive({ v: null })
    const isAdd = computed(() => (record.v ? false : true))

    function open(recordParam) {
      visible.value = true
      if (recordParam) {
        record.v = cloneDeep(recordParam)
        renderForm(cloneDeep(recordParam))
      }
    }

    function close() {
      visible.value = false
      record.v = null
      formModel.form = cloneDeep(defaultForm)
    }

    // form回显
    function renderForm(data) {
      // 处理noticeContent // 因为saas商城和在线问诊 这俩项目的 这个组件，数据格式不一样
      const arr = JSON.parse(data.noticeContent ?? '[]')
      const noticeContentArr = arr.map((item) => {
        let type
        if (item.type == 1) {
          type = 'text'
        } else if (item.type == 2) {
          type = 'image'
        }
        return {
          id: item.id,
          type,
          content: item.value,
        }
      })
      const noticeContent = JSON.stringify(noticeContentArr)
      // 处理noticeContent end

      formModel.form = {
        ...data,
        noticeContent,
      }
    }

    // 提交
    async function submit() {
      await validateFormRef(formRef)

      const postData = {
        ...(isAdd.value ? {} : { textCode: record.v.textCode }),
        ...formModel.form,
      }
      submitLoading.value = true
      request({
        url: isAdd.value ? '/web/system/active/createActive' : '/web/system/active/updateActive',
        data: postData,
      })
        .finally(() => {
          submitLoading.value = false
        })
        .then(() => {
          ctx.emit(isAdd.value ? 'successAdd' : 'successEdit')
          close()
        })
    }

    return {
      visible,
      isAdd,
      submitLoading,
      open,
      close,
      submit,
      //
      formRef,
      formModel,
    }
  },
  components: { StyledModal, FetchSelect, ImgUpload, DetailEditor },
}
</script>

<style lang="less">
.input_refTargetUrl {
  textarea {
    min-height: 170px !important;
  }
}
</style>

<style lang="less" scoped>
.form_box {
  width: 90%;
}
</style>
